import { styled } from '@mui/system'
import { FilterLiveSearch } from 'react-admin'

export const FilterLiveStyled = styled(FilterLiveSearch)`
  width: 500px;
`
